/**
 * Checks if the format string contains time-related tokens.
 */
export function containsTimeFormat(format: string) {
  return !!format.match(/[hHmsS]+/);
}
